import { useApi } from "@/hooks/use-api";
import { SpacesResponseApi } from "./get-spaces.types";

export const GetSpacesApi = () => {
  const { data }: SpacesResponseApi = useApi({
    path: `/spaces?type=simplelist&include_floors=true`,
    method: "get",
  });

  const spaces = data._embedded.spaces.map((item) => {
    return {
      id: item.id,
      name: item.name,
    };
  });

  return {
    data: spaces,
  };
};
